import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import InfoTooltip from '../../Components/InfoTooltip'
import { getStarColorClass } from '../../Functions/RatingLabelColor';
import StarRating from '../../Components/StarRating'
import API from "../../Api/Api";
import { getPerformanceRating } from '../../Functions/Constant';
import InfoTooltipRating from '../../Components/InfoTooltipRating'
import ButtonsVariant from '../../Components/Button/ButtonVariant'; // Fixed: Use default import
const ReviewSummarySection = ({ ratings, mainRating, type, scrollToReviews, data }) => {

    // const handleDownload = async () => {
    //     try {
    //         const endpoint = `/user`;
    //         const res = await API.get(endpoint);
    //         if (res.user) {
    //             console.log(res.user.user_id);
    //             window.location.href = "https://assets.jobcritics.com/pdf/user_pdf.php?user_id=" + res.user.user_id;
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     } finally {
    //     }

    //     //pdfComponentRef.current?.downloadPDF(userData, ratings);
    // };
    const generateFileName = (name) => {
        if (!name) return 'Career Report.pdf'; // Fallback if name is empty
        return `${name.charAt(0).toUpperCase() + name.slice(1)}'s Career Report.pdf`;
      };
    const handleDownload = async () => {
        try {
          const endpoint = `/user`;
          const res = await API.get(endpoint);
          if (res.user) {
            const fileName = generateFileName(res.user.name);
            const userId = res.user.user_id;
      
            // Construct the PDF download URL
            const pdfUrl = `https://assets.jobcritics.com/pdf/user_pdf.php?user_id=${userId}`;
      
            // Fetch the PDF as a blob
            const response = await fetch(pdfUrl);
            if (!response.ok) {
              throw new Error('Failed to fetch PDF');
            }
            const blob = await response.blob();
      
            // Create a temporary URL for the blob
            const url = window.URL.createObjectURL(blob);
      
            // Create a temporary anchor element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName; // Set a default filename
            document.body.appendChild(link);
            link.click();
      
            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        } catch (error) {
          console.error('Error downloading PDF:', error);
        }
      };


    return (
        <section className="pt-[40px] pb-[14px] ">
            <Container>
                <Row className="align-items-baseline">
                    <Col lg={12} md={12} xs={6} className="mb-6 md:mb-0 ">
                        <h3 className="text-[28px] font-bold text-black mb-0 text-[#000] xs:text-[22px]">Overall Rating <InfoTooltip text="Based on feedback from friends, colleagues, managers, and professors about your skills." /></h3>
                    </Col>
                    {data.length > 3 && (
                        <Col xs={6} className="mb-6 md:mb-0 hjs xs:text-center">
                            {/* <button className="btn-explore-white px-4 py-2 font-bold rounded-md ml-4" onClick={handleDownload}>
                                <span className="mr-2">Career Report</span>
                            </button> */}
                            <ButtonsVariant
                                ariaLabel="button"
                                href="#"
                                className="mx-[10px]"
                                variant="whiteToBlack"
                                size="sm"
                                title="Career Report"
                                onClick={handleDownload}
                            />

                        </Col>
                    )}

                </Row>
                <Row className="justify-between items-center">
                    {/* Overall Rating Section (Left) */}
                    <Col lg={2} md={12} className="mb-6 md:mb-0 leading-[1.4]">
                        <div>
                            <div className="text-[50px] font-bold leading-[1.2] text-[#000] lt">{ratings.overall_rating.toFixed(1)}</div>
                            <InfoTooltipRating className="font-medium text-[18px] text-[#000]" rating={ratings.overall_rating} />

                            <div className="flex  mt-0">
                                <StarRating rating={ratings.overall_rating} starSize={15} />
                                {/* {[...Array(5)].map((_, index) => (
                                    <span key={index} className={` ${index < ratings.overall_rating ? "yellow-class" : "text-gray-300"}`}>
                                        <i className="fas fa-star"></i>
                                    </span>
                                ))} */}
                            </div>

                            <span className={`text-gray-600 text-[14px]  ${ratings.total_reviews > 0 ? `cursor-pointer hover:underline hover:text-black transition` : ""}`} onClick={scrollToReviews}>{ratings.total_reviews > 0 ? `${ratings.total_reviews} Reviews` : "No Reviews Yet"}</span>
                        </div>
                    </Col>

                    <Col lg={4} md={12} sm={12} className="border-r-2 border-gray-300 leading-[1.8] pr-[19px] bol sm:border-r-0 md:border-r-0 md:pr-[0px] sm:pr-[0px]">
                        {[
                            { label: 5, value: ratings.excellent, max: ratings.total_reviews },
                            { label: 4, value: ratings.very_good, max: ratings.total_reviews },
                            { label: 3, value: ratings.average, max: ratings.total_reviews },
                            { label: 2, value: ratings.poor, max: ratings.total_reviews },
                            { label: 1, value: ratings.terrible, max: ratings.total_reviews },
                        ].map((item, index) => (
                            <div key={index} className="flex items-center justify-between space-x-2">
                                <span className="text-gray-900 text-sm font-medium w-[80px]"  >{getPerformanceRating(item.label).level}</span>
                                <div className="flex-1 h-[12px] bg-gray-200 rounded-full overflow-hidden">
                                    <div className="h-full yellow-b" style={{ width: `${item.max ? (item.value / item.max) * 100 : 0}%` }}></div>
                                </div>
                                <span className="text-[#000] text-[14px] w-[40px] text-start pl-[8px]">{item.value}</span>
                            </div>
                        ))}
                    </Col>
                    <Col lg={6} md={12} sm={12} className="pl-[45px] rpl sm:pt-[20px] md:pt-[20px] md:pl-[17px]">
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-1 gap-y-3 gap-x-4">
                            {[
                                { label: 'Core Skills', rating: mainRating.core.toFixed(1) },
                                { label: 'Creativity & Innovation', rating: mainRating.creativity.toFixed(1) },
                                { label: 'Personal Effectiveness', rating: mainRating.personal.toFixed(1) },
                                { label: 'Technical & Analytical Skills', rating: mainRating.technical.toFixed(1) },
                                { label: 'Interpersonal Skills', rating: mainRating.interpersonal.toFixed(1) }
                            ].map((item, index) => (
                                <div key={index} className="flex flex-col justify-center items-start leading-[1]">
                                    <div className="leading-[1.4] flex items-center h-[20px]">
                                        <span className="font-medium text-[14px] text-[#000]">{item.label}</span>
                                    </div>
                                    <div className="flex items-center w-full">
                                        <div className="w-[78%] h-[12px] bg-gray-200 rounded-full overflow-hidden mr-2 sm:w-[94%] xs:w-[92%] md:w-[95%] ">
                                            <div className="h-full yellow-b" style={{ width: `${(item.rating / 5) * 100}%` }}></div>
                                        </div>
                                        <div>
                                            <span className="text-[#000] text-[14px]">{item.rating}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>


                </Row>
            </Container>
        </section>
    )
}

export default ReviewSummarySection
